import React from 'react';

import Layout from '../layouts/ProgramDashboard';
import TravelerProgramDashboard from '../components/TravelerProgramDashboard';
import PageWrapper from '../components/base/PageWrapper';

export default function Page() {
  return {
    title: 'Program Dashboard',
    component: (
      <Layout>
        <PageWrapper routeSegment="Program">
          <TravelerProgramDashboard />
        </PageWrapper>
      </Layout>
    ),
  };
}
